// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vlvh","placeholdersHeader":"styles_placeholdersHeader__3sSuA","editorStyle":"styles_editorStyle__31__0","placeholdersBox":"styles_placeholdersBox__1vbBQ"};